import React, { type ButtonHTMLAttributes } from 'react';
import c from 'classnames';

import { Button as RKSButton } from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

export interface ButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'type'> {
  type?: 'primary' | 'secondary';
  variant?: 'icon-only';
  withThemeColor?: boolean;
  icon?: string;
  htmlType?: string;
  loading?: boolean;
}

const Button: React.FC<ButtonProps> = (props) => {
  const {
    type,
    variant,
    withThemeColor = false,
    icon,
    className,
    children,
    htmlType,
    loading,
    ...restProps
  } = props;

  const classNames = c('button', className, {
    [`button--${String(type)}`]: type,
    'button--theme-color': withThemeColor,
    [`button--variant--${String(variant)}`]: variant,
    'icon-after': icon,
    [`icon-${String(icon)}`]: icon,
  });

  return (
    <RKSButton
      {...restProps}
      primary={false}
      className={classNames}
      htmlType={htmlType}
      loading={loading}
    >
      {variant !== 'icon-only' && children}
    </RKSButton>
  );
};

export default Button;
